import { observable, action } from 'mobx';
import ApiCaller from '../utils/api-caller';

class RoomSetupStore {

    // Properties

    // Modal Create/Update Properties

    @observable showRoomSetupModal = false;
    @observable roomSetupTitle = '';

    @observable roomSetups = [];
    @observable roomAndRoomTypeId = 0;
    @observable roomTypeId = 0;
    @observable roomTypeName = '';
    @observable roomId = 0;
    @observable roomName = '';
    @observable roomSetupTextButton = 'Create';

    // Modal Search Room Properties

    @observable showRoomSearchModal = false;
    @observable rooms = [];
    @observable roomFilter = [];
    @observable roomSearchValue = '';

    // Modal Search Room Type Properties

    @observable showRoomTypeSearchModal = false;
    @observable roomTypes = [];
    @observable roomTypeFilter = [];
    @observable roomTypeSearchValue = '';

    // Helper Properties

    @observable roomSetupListLoading = false;
    @observable roomSetupModalLoading = false;

    // Initialization

    @action initRoomSetup() {
        this.roomSetupListLoading = true;

        ApiCaller.RoomSetups.apiGetRoomAndRoomTypes().then(roomSetupResponses => {
            if (!roomSetupResponses.isError) {
                this.roomSetups = roomSetupResponses.data;

                ApiCaller.RoomSetups.apiGetRooms().then((roomResponses) => {
                    if (!roomResponses.isError) {
                        this.rooms = roomResponses.data;
                        this.roomFilter = this.rooms;
                    } else {
                        this.rooms = [];
                        this.roomFilter = this.rooms;
                    }

                    ApiCaller.RoomSetups.apiGetRoomTypes().then((roomTypeResponses) => {
                        if (!roomTypeResponses.isError) {
                            this.roomTypes = roomTypeResponses.data;
                            this.roomTypeFilter = this.roomTypes;
                        } else {
                            this.roomTypes = [];
                            this.roomTypeFilter = this.roomTypes;
                        }
    
                        this.roomSetupListLoading = false;
                    });
                });
            } else {
                this.roomSetups = [];
                this.roomSetupListLoading = false;
            }
        });
    }

    @action initCreateRoomSetup() {
        this.roomSetupTitle = 'Create Room Setup';

        this.roomAndRoomTypeId = 0;
        this.roomTypeId = 0;
        this.roomTypeName = '';
        this.roomId = 0;
        this.roomName = '';

        this.roomSetupTextButton = 'Create';
        this.showRoomSetupModal = true;
    }

    @action initUpdateRoomSetup(roomAndRoomTypeId) {
        this.roomSetupModalLoading = true;
        this.roomSetupTitle = 'Update Room Setup';
        this.roomSetupTextButton = 'Update';
        this.showRoomSetupModal = true;

        ApiCaller.RoomSetups.apiGetRoomAndRoomTypeById(roomAndRoomTypeId).then(roomSetupResponse => {
            if (!roomSetupResponse.isError) {
                if (roomSetupResponse.data) {
                    this.roomAndRoomTypeId = roomSetupResponse.data.roomAndRoomTypeId;
                    this.roomTypeId = roomSetupResponse.data.roomTypeId;
                    this.roomTypeName = roomSetupResponse.data.roomTypeName;
                    this.roomId = roomSetupResponse.data.roomId;
                    this.roomName = roomSetupResponse.data.roomName;
                } else {
                    this.roomAndRoomTypeId = 0;
                    this.roomTypeId = 0;
                    this.roomTypeName = '';
                    this.roomId = 0;
                    this.roomName = '';
                }
            } else {
                this.roomAndRoomTypeId = 0;
                this.roomTypeId = 0;
                this.roomTypeName = '';
                this.roomId = 0;
                this.roomName = '';
            }

            this.roomSetupModalLoading = false;
        });
    }

    // Transaction - Room

    @action searchRoom() {
        this.roomFilter = this.rooms.filter(room => {
            let roomName = room.roomName.toLowerCase();
            return roomName.indexOf(this.roomSearchValue.toLowerCase()) !== -1;
        });
    }

    @action searchRoomSelected(roomId) {
        const room = this.rooms.find(x => x.roomId === roomId);
        this.roomId = roomId;
        this.roomName = room.roomName;
    }

    // Transaction - Room Type

    @action searchRoomType() {
        this.roomTypeFilter = this.roomTypes.filter(roomType => {
            let roomTypeName = roomType.roomTypeName.toLowerCase();
            return roomTypeName.indexOf(this.roomTypeSearchValue.toLowerCase()) !== -1;
        });
    }

    @action searchRoomTypeSelected(roomTypeId) {
        const roomType = this.roomTypes.find(x => x.roomTypeId === roomTypeId);
        this.roomTypeId = roomTypeId;
        this.roomTypeName = roomType.roomTypeName;
    }

    // Transaction Room Setup

    @action createRoomSetup() {
        this.roomSetupModalLoading = true;

        const newRoomSetup = {
            'roomAndRoomTypeId': 0,
            'roomTypeId': this.roomTypeId,
            'roomId': this.roomId
        };

        return ApiCaller.RoomSetups.apiCreateRoomAndRoomType(newRoomSetup).then((createRoomSetupResponse) => {
            this.roomSetupModalLoading = false;
            
            if (!createRoomSetupResponse.isError) {
                this.showRoomSetupModal = false;
            }

            return createRoomSetupResponse;
        });
    }

    @action updateRoomSetup() {
        this.roomSetupModalLoading = true;

        const updateRoomSetup = {
            'roomAndRoomTypeId': this.roomAndRoomTypeId,
            'roomId': this.roomId,
            'roomTypeId': this.roomTypeId,
        };

        return ApiCaller.RoomSetups.apiUpdateRoomAndRoomType(this.roomAndRoomTypeId, updateRoomSetup).then((updateRoomSetupResponse) => {
            this.roomSetupModalLoading = false;

            if (!updateRoomSetupResponse.isError) {
                this.showRoomSetupModal = false;
            }

            return updateRoomSetupResponse;
        });
    }

    @action deleteRoomSetup(roomAndRoomTypeId) {
        this.roomSetupListLoading = true;

        return ApiCaller.RoomSetups.apiDeleteRoomAndRoomTypeById(roomAndRoomTypeId).then((deleteRoomSetupResponse) => {
            this.roomSetupListLoading = false;

            if (!deleteRoomSetupResponse.isError) {
                this.initRoomSetup();
            }

            return deleteRoomSetupResponse;
        });
    }

    // SET Properties

    @action setShowRoomSetupModal(value) {
        this.showRoomSetupModal = value;
    }

    @action setShowRoomSearchModal(value) {
        this.showRoomSearchModal = value;
    }

    @action setShowRoomTypeSearchModal(value) {
        this.showRoomTypeSearchModal = value;
    }

    @action setRoomSearchValue(value) {
        this.roomSearchValue = value
    }

    @action setRoomTypeSearchValue(value) {
        this.roomTypeSearchValue = value
    }
}

export default new RoomSetupStore()